import { t } from '@/plugins/i18n'

// 银行卡便捷支付新手引导
export interface BGL {
  startTop: number | string // 透明块左上角距离顶部的距离 y轴
  startLeft: number | string // 透明块左上角距离左侧的距离 x轴
  boxWidth: number | string // 透明块宽度
  boxHeight: number | string // 透明块高度
  boxRadio: number | string // 透明块圆角
  lineTop: number | string // 箭头top
  lineLeft: number | string // 箭头left
  lineRotate?:number // 箭头旋转
  title?: string // 步骤标题
  text?: string // 步骤标题
  isReturn?: boolean // 是否显示跳过
  dialogTop?: number // 弹窗的顶部
  dialogLeft?: number // 弹窗的左侧距离

}

export const getBlankGuideList: any = () => {
  const list = []
  const padding = 20
  // 第一步
  const ele0 = document.querySelector('#tab-fastBankCard')?.getBoundingClientRect()
  if (ele0) {
    list.push({
      startTop: (ele0.top || 0) - padding,
      startLeft: (ele0.left || 0) - padding,
      boxWidth: (ele0.width || 0) + 2 * padding,
      boxHeight: ele0.height + 2 * padding,
      boxRadio: 20,
      lineTop: (ele0.top || 0) - padding + 40,
      lineLeft: (ele0.left || 0) + (ele0.width || 0) - padding + 2 * padding + 9,
      dialogTop: (ele0.top || 0) - 80,
      dialogLeft: (ele0.left || 0) + (ele0.width || 0) - padding + 2 * padding + 180,
      title: 'Step1：',
      text: t('銀行振込に振込方法が追加口座反映スピードが大幅向上！'),
      isReturn: true
    })
  }
  // 第二步
  const ele1 = document.querySelector('.fast-bank-step-item-step1')?.getBoundingClientRect()
  const ele2 = document.querySelector('.fast-bank-pay-popover-content')?.getBoundingClientRect()
  if (ele1 && ele2) {
    list.push({
      startTop: (ele1.top || 0) - padding,
      startLeft: (ele2.left || 0) - padding,
      boxWidth: (ele2.width || 0) + 2 * padding,
      boxHeight: ele1.height + ele2.height + 2 * padding,
      boxRadio: 20,
      lineTop: (ele1.top || 0) - padding + 105,
      lineLeft: (ele2.left || 0) - padding + (ele2.width || 0) + 2 * padding + 9,
      dialogTop: (ele1.top || 0) - padding,
      dialogLeft: (ele2.left || 0) - padding + (ele2.width || 0) + 2 * padding + 180,
      title: 'Step2：',
      text: t('复制收款银行信息，去线下银行转账至我们的收款银行'),
      isReturn: true
    })
  } else {
    list.push({})
  }
  const ele3 = document.querySelector('.card-item-empty')?.getBoundingClientRect()
  if (ele3) {
    list.push({
      startTop: (ele3.top || 0) - padding,
      startLeft: (ele3.left || 0) - padding,
      boxWidth: (ele3.width || 0) + 2 * padding,
      boxHeight: ele3.height + 2 * padding,
      boxRadio: 20,
      lineTop: (ele3.top || 0) - padding + 115,
      lineLeft: (ele3.left || 0) - padding + (ele3.width || 0) + 2 * padding + 9,
      dialogTop: (ele3.top || 0) - padding,
      dialogLeft: (ele3.left || 0) - padding + (ele3.width || 0) + 2 * padding + 180,
      title: 'Step3：',
      text: t('线下银行转账成功后，您可以在这里绑定您自己的银行卡信息'),
      isReturn: true
    })
  } else {
    list.push({})
  }
  const ele4 = document.querySelector('.card-input-number')?.getBoundingClientRect()
  if (ele4) {
    list.push({
      startTop: (ele4.top || 0),
      startLeft: (ele4.left || 0) - padding,
      boxWidth: 540,
      boxHeight: 70,
      boxRadio: 20,
      lineTop: (ele4.top || 0) - 95,
      lineLeft: (ele4.left || 0) - padding + 270 - 85,
      dialogTop: (ele4.top || 0) - 180 - 250,
      dialogLeft: (ele4.left || 0) - padding,
      title: 'Step4：',
      text: t('输入金额，点击“确定”按钮，提交支付信息'),
      isReturn: true,
      lineRotate: -90
    })
  } else {
    list.push({})
  }
  return list
}
